module.exports = {"511529100":"锦屏镇","511529101":"新市镇","511529102":"中都镇","511529103":"龙华镇","511529104":"大乘镇","511529107":"新安镇","511529109":"书楼镇","511529110":"屏山镇","511529208":"夏溪乡","511529210":"屏边彝族乡","511529211":"清平彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511529.json
// module id = 2496
// module chunks = 0